var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSportsbookFavourites({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-editor-id": "expandedNavbarIcon",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    style: {
      fill: "currentcolor",
      color: "currentcolor",
      width: 18,
      height: "auto"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.169 2.601c0.632-1.671 3.030-1.671 3.662 0l3.097 8.19 9.162 0.279c1.71 0.052 2.697 2.291 1.114 3.463l-7.189 5.324 2.528 8.314c0.274 0.9-0.147 1.711-0.747 2.127-0.594 0.411-1.457 0.513-2.197 0.034l-7.597-4.919-7.597 4.919c-0.74 0.479-1.604 0.377-2.197-0.034-0.6-0.416-1.021-1.227-0.748-2.127l2.528-8.314-7.189-5.324c-1.583-1.173-0.596-3.411 1.114-3.463l9.162-0.279 3.097-8.19zM16 5.291l-2.607 6.897c-0.287 0.761-1.007 1.229-1.77 1.252l-7.517 0.229 5.887 4.36c0.638 0.472 0.938 1.3 0.698 2.091l-2.104 6.92 6.341-4.105c0.651-0.422 1.495-0.422 2.146 0l6.341 4.105-2.104-6.92c-0.241-0.791 0.060-1.619 0.698-2.091l5.887-4.36-7.516-0.229c-0.764-0.023-1.483-0.492-1.77-1.252l-2.608-6.897zM29.617 12.393v0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSportsbookFavourites);
export default __webpack_public_path__ + "static/media/sportsbookFavourites.de925c2cd519fbb401f7596ac21f192b.svg";
export { ForwardRef as ReactComponent };